module.exports = __webpack_public_path__ + "img/15.7b3314b2.gif";